import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';

import ErrorBoundary from 'components/ErrorBoundary/ErrorBoundary';
import { trackEvent } from 'helpers/trackerHelpers';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';
import { GetLayoutChartDataResponse } from 'components/ChartContainer/types';
import { groupBy } from 'lodash';
import TimeFilterModalItem from './TimeFilterModalItem';

type TimeFilters = GetLayoutChartDataResponse['timeFilters'];

interface TimeFilterModalProps {
    timeFilters: TimeFilters;
    closeModal: () => void;
}

const TimeFilterModal = ({ timeFilters, closeModal }: TimeFilterModalProps) => {
    const { t } = useTranslation();

    React.useEffect(() => {
        trackEvent(
            'decision/dashboard/indicator/time-filter-descriptionmodal-open',
        );
    }, []);

    const timeFiltersByMetrics = groupBy(
        timeFilters,
        (filter) =>
            `${filter.filteredMetric.field}-${filter.filteredMetric.aggregation}`,
    );
    return (
        <ErrorBoundary>
            <Dialog
                open
                onClose={closeModal}
                sx={{ maxHeight: '80vh' }}
                fullWidth
            >
                <DialogTitle component={Box}>
                    <Typography variant="h4">
                        {t('timeFilterModal.title')}
                    </Typography>
                </DialogTitle>
                <DialogContent>
                    {timeFilters.length === 0 ? (
                        <Box sx={{ p: '10px' }}>
                            {t('timeFilterTooltip.noTimeFilter')}
                        </Box>
                    ) : (
                        Object.entries(timeFiltersByMetrics).map(
                            ([metricField, filters]) => {
                                const metric = filters[0].filteredMetric;
                                return (
                                    <TimeFilterModalItem
                                        key={metricField}
                                        metric={metric}
                                        timeFilters={filters}
                                    />
                                );
                            },
                        )
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={closeModal}>{t('common.close')}</Button>
                </DialogActions>
            </Dialog>
        </ErrorBoundary>
    );
};

export default TimeFilterModal;
